import React from 'react';
import { useTranslation } from 'react-i18next';
import FileUploadStatus from '../../../Components/KenFileUploadStatus/index';
import MUIDataTable from 'mui-datatables';
import {
  MuiThemeProvider,
  createTheme,
  makeStyles,
  useTheme,
} from '@material-ui/core/styles';
import { overridings as lightTheme } from '../../../Utils/themes/light-theme';

const useStyles = makeStyles((theme) => ({}));

export default function BasicTable(props) {
  const classes = useStyles();
  const { data } = props;
  const { t } = useTranslation();
  const theme = useTheme();

  const columns = [
    {
      name: 'name',
      label: 'STEP NAME',
      options: {
        filter: false,
        sort: false,
      },
    },

    {
      name: 'status',
      label: t('status'),
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value, tableMeta, updateValue) => (
          <FileUploadStatus value={value} />
        ),
      },
    },
  ];

  const tableTheme = createTheme({
    ...lightTheme,
    overrides: {
      MuiTable: {
        root: {
          width: '650px',
          [theme.breakpoints.down('xs')]: {
            width: '100%',
          },
        },
      },
      MuiTableCell: {
        root: {
          borderBottom: 'none',
          padding: '12px 10px',
          fontSize: '14px',
          borderBottom: `1px solid ${theme.palette.KenColors.neutral40}`,
        },
      },
      MUIDataTableBodyCell: {
        [theme.breakpoints.down('xs')]: {
          fontSize: 12,
        },
      },
    },
  });

  const muiDataTableOptions = {
    selectableRows: 'none',
    download: false,
    filter: false,
    print: false,
    viewColumns: false,
    search: false,
    expandableRowsHeader: true,
    pagination: false,
    rowsPerPageOptions: [10, 20, 30],
    filterType: 'dropdown',
  };
  return (
    <MuiThemeProvider theme={tableTheme}>
      <MUIDataTable
        data={data}
        columns={columns}
        options={muiDataTableOptions}
      />
    </MuiThemeProvider>
  );
}
